import React from 'react';
import { motion } from 'framer-motion';
const before = ['Mensaje', 'Persona responde', 'Copia información', 'Actualiza CRM', 'Pregunta disponibilidad', 'Busca calendario', 'Confirma', 'Recuerda', 'Hace seguimiento'];
const withOrigen = ['Mensaje', 'IA', 'Califica', 'CRM', 'Agenda', 'Seguimiento'];
export function ResultSection() {
  return <section id="resultados" className="bg-arena py-[72px] md:py-[120px]" data-id="element-180" data-mp="1bn2djctt2hmy">
      <div className="max-w-[1000px] mx-auto px-6 md:px-20" data-id="element-181" data-mp="297okgo8i0ax8">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="text-center max-w-[560px] mx-auto mb-14" data-id="element-182" data-mp="2494ywoxth15e">
          <h2 className="font-display text-[32px] md:text-[44px] font-bold text-carbon leading-[1.1]" data-id="element-183" data-mp="2n6ob21fkmzw1">
            Menos tareas repetitivas. Más procesos funcionando.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16" data-id="element-184" data-mp="2kpym67hh04h6">
          {/* ANTES */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.4,
          ease: 'easeOut'
        }} data-id="element-185" data-mp="26yjxpl4snb2q">
            <span className="block font-body text-[11px] uppercase font-medium text-carbon/35 tracking-[0.15em] mb-6" data-id="element-186" data-mp="1o220io76eiz3">
              ANTES
            </span>
            <div className="flex flex-col gap-1.5" data-id="element-187" data-mp="3idp2cuohjjoz">
              {before.map((step, idx) => <React.Fragment key={step} data-id="element-188" data-mp="3nduyan1sfscv" data-mpi={idx}>
                  <span className="font-body text-[13px] text-carbon/50 bg-carbon/5 rounded-[8px] px-3.5 py-2 w-fit" data-id="element-189" data-mp="3ncjwgsrwkuoe">
                    {step}
                  </span>
                  {idx < before.length - 1 && <span className="text-carbon/20 text-[12px] pl-3.5" data-id="element-190" data-mp="3gzfnzbryqpyg">↓</span>}
                </React.Fragment>)}
            </div>
          </motion.div>

          {/* CON ORIGEN */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.4,
          ease: 'easeOut',
          delay: 0.1
        }} data-id="element-191" data-mp="8h031661ff3e">
            <span className="block font-body text-[11px] uppercase font-medium text-verde tracking-[0.15em] mb-6" data-id="element-192" data-mp="r8svmzh72yal">
              CON ORIGEN
            </span>
            <div className="flex flex-col gap-1.5" data-id="element-193" data-mp="ts721qsnigy8">
              {withOrigen.map((step, idx) => <React.Fragment key={step} data-id="element-194" data-mp="yra91gs6yx8u" data-mpi={idx}>
                  <span className="font-body text-[14px] font-medium text-arena bg-verde rounded-[8px] px-3.5 py-2.5 w-fit" data-id="element-195" data-mp="ysbn7u4i7zus">
                    {step}
                  </span>
                  {idx < withOrigen.length - 1 && <span className="text-verde/40 text-[12px] pl-3.5" data-id="element-196" data-mp="18nd8ufzkmjsm">↓</span>}
                </React.Fragment>)}
            </div>
          </motion.div>
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: 0.2
      }} className="text-center font-display text-[18px] md:text-[20px] font-semibold text-carbon mt-14 max-w-[540px] mx-auto" data-id="element-197" data-mp="1ho1nncwsgo6k">
          La automatización no reemplaza tu operación. La hace funcionar
          mejor.
        </motion.p>
      </div>
    </section>;
}